// extracted by mini-css-extract-plugin
module.exports = {"popper-arrow":"styles_popper-arrow__1TScC","paper":"styles_paper__3fZoT","paperSwatch":"styles_paperSwatch__3GgsH"};